import _ from "lodash";
import { CONTRACTOR, FEEDERLISTS } from "../_constants/actionConstants";

const contractorsInitialState = {
  contractorList: {}, // Normalized by tabId, for pagination
  projContractorLists: {}, // Normalized by projectId
  openContractorDetails: {}, // Normalized by contractorId
  openProjContractorDetails: {}, // Normalized by projectId, then by contractorId
  miscSessionData: {},
  fetching: false,
  error: null,
};

export const reducer = (state = contractorsInitialState, action) => {
  switch (action.type) {
    case CONTRACTOR.ADD:
    case CONTRACTOR.EDIT:
    case CONTRACTOR.EDIT_PROJECT_CONTRACTORS:
    case CONTRACTOR.EDIT_PROJECT_CONTRACTOR_DETAILS:
    case CONTRACTOR.DELETE:
    case CONTRACTOR.FETCH_DETAILS:
    case CONTRACTOR.FETCH_ALL:
    case CONTRACTOR.FETCH_ALL_FOR_PROJECT:
    case CONTRACTOR.FETCH_PROJECT_CONTRACTOR_DETAILS:
    case CONTRACTOR.FETCH_PROJECT_CONTRACTORS_WITH_LINKS:
      return { ...state, fetching: true };

    case CONTRACTOR.FETCH_DETAILS_FULFILLED: {
      const { contractorId, payload } = action;
      if (!contractorId) return { ...state, fetching: false };
      return {
        ...state,
        fetching: false,
        openContractorDetails: {
          ...state.openContractorDetails,
          [contractorId]: payload,
        },
      };
    }

    case CONTRACTOR.FETCH_DETAILS_REJECTED: {
      const { contractorId } = action;
      if (!contractorId) return { ...state, fetching: false };
      return {
        ...state,
        fetching: false,
        openContractorDetails: {
          ...state.openContractorDetails,
          [contractorId]: { error: true },
        },
      };
    }

    case CONTRACTOR.FETCH_PROJECT_CONTRACTOR_DETAILS_FULFILLED: {
      const { projectId, contractorId, payload } = action;
      if (!contractorId || !projectId) return { ...state, fetching: false };
      return {
        ...state,
        fetching: false,
        openProjContractorDetails: {
          ...state.openProjContractorDetails,
          [projectId]: {
            ...state.openProjContractorDetails[projectId],
            [contractorId]: payload,
          },
        },
      };
    }

    case CONTRACTOR.EDIT_PROJECT_CONTRACTOR_DETAILS_FULFILLED: {
      const { projectId, contractorId, projContractorDetails, projContractorList } =
        action;
      if (!contractorId || !projectId) return { ...state, fetching: false };
      return {
        ...state,
        fetching: false,
        projContractorLists: {
          ...state.projContractorLists,
          [projectId]: projContractorList || state.projContractorLists[projectId] || [],
        },
        openProjContractorDetails: {
          ...state.openProjContractorDetails,
          [projectId]: {
            ...state.openProjContractorDetails[projectId],
            [contractorId]: projContractorDetails,
          },
        },
      };
    }

    case CONTRACTOR.CLEAR_ALL_DETAILS: {
      return { ...state, openContractorDetails: {} };
    }

    case CONTRACTOR.DELETE_FULFILLED:
    case CONTRACTOR.CLEAR_DETAILS: {
      const { contractorId } = action;
      if (!contractorId || !(contractorId in state.openContractorDetails))
        return { ...state, fetching: false };
      let openContractorDetails = _.cloneDeep(state.openContractorDetails);
      delete openContractorDetails[contractorId];
      return { ...state, openContractorDetails, fetching: false };
    }

    case CONTRACTOR.CLEAR_PROJECT_CONTRACTOR_DETAILS: {
      const { projectId, contractorId } = action;
      if (
        !projectId ||
        !contractorId ||
        !(projectId in state.openProjContractorDetails) ||
        !(contractorId in state.openProjContractorDetails[projectId])
      )
        return { ...state, fetching: false };

      let openProjContractorDetails = _.cloneDeep(state.openProjContractorDetails);
      delete openProjContractorDetails[projectId][contractorId];
      return { ...state, fetching: false, openProjContractorDetails };
    }

    case CONTRACTOR.CLEAR_LIST: {
      const { tabId } = action;
      if (tabId == null) return { ...state };

      let contractorList = _.cloneDeep(state.contractorList);
      if (tabId in contractorList) delete contractorList[tabId];

      return { ...state, contractorList };
    }

    case CONTRACTOR.CLEAR_MISC_SESSION_DATA: {
      const { tabId } = action;
      if (tabId == null) return { ...state };
      let miscSessionData = _.cloneDeep(state.miscSessionData);
      if (tabId in miscSessionData) delete miscSessionData[tabId];
      return { ...state, miscSessionData };
    }

    case CONTRACTOR.EDIT_FULFILLED: {
      const { contractorId, contractorDetails } = action;
      if (!contractorId || contractorId in state.openContractorDetails)
        return { ...state, fetching: false };
      return {
        ...state,
        fetching: false,
        openContractorDetails: {
          ...state.openContractorDetails,
          [contractorId]: contractorDetails,
        },
      };
    }

    case CONTRACTOR.ADD_FULFILLED:
    case CONTRACTOR.EDIT_PROJECT_CONTRACTORS_FULFILLED:
    case FEEDERLISTS.FETCH_FULFILLED: {
      const { projectId, projContractorList } = action;
      if (!projectId) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projContractorLists: {
          ...state.projContractorLists,
          [projectId]: projContractorList || state.projContractorLists[projectId] || [],
        },
      };
    }

    case CONTRACTOR.SET_SEARCH_WAITINGFOR: {
      const { tabId, waitingFor } = action;
      if (tabId == null) return { ...state };
      return {
        ...state,
        miscSessionData: {
          ...state.miscSessionData,
          [tabId]: {
            ...state.miscSessionData[tabId],
            searchWaitingFor: waitingFor,
          },
        },
      };
    }

    case CONTRACTOR.FETCH_ALL_FULFILLED: {
      const { tabId, contractorList, resetList, searchString } = action;
      if (tabId == null) return { ...state, fetching: false };

      if (
        tabId in state.miscSessionData &&
        (state.miscSessionData[tabId].searchWaitingFor || "") === searchString
      )
        // resetList takes whatever is incoming as the entire userList.
        // resetList will be true when filters are cleared, etc., and will be
        // false when paging thru the data. Going to next page will fetch
        // additional data and append to existing employeeList.
        return {
          ...state,
          fetching: false,
          contractorList: {
            ...state.contractorList,
            [tabId]: resetList
              ? contractorList
              : [...(state.contractorList[tabId] || []), ...contractorList],
          },
        };
      else return { ...state, fetching: false };
    }

    case CONTRACTOR.FETCH_ALL_FOR_PROJECT_FULFILLED: {
      const { projectId, projContractorList } = action;
      if (!projectId) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projContractorLists: {
          ...state.projContractorLists,
          [projectId]: projContractorList || state.projContractorLists[projectId] || [],
        },
      };
    }

    case CONTRACTOR.FETCH_PROJECT_CONTRACTORS_WITH_LINKS_FULFILLED: {
      const { tabId, payload } = action;
      if (tabId == null) return { ...state, fetching: false };
      return {
        ...state,
        fetching: false,
        miscSessionData: {
          ...state.miscSessionData,
          [tabId]: {
            ...state.miscSessionData[tabId],
            contractorsWithLinks: payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
